<template>
  <div class="company-contain">
    <div class="content_box">
      <div class="left_menu">
        <div class="menu_item" :class="currentMenu==item.id?'active_menu_item':''" v-for="item in menuData" :key="item.id" @click="changeMenu(item.id)">
          <span> {{ item.name }}</span>
          <span style="display: flex;align-items: center;">
            <span style="margin-right: 5px;" v-if="item.id==1">{{item.current_num  }}/{{item.number  }}</span>
            <i class="el-icon-arrow-right"></i>
          </span>
        </div>

      </div>
      <div class="right_box">
        <el-scrollbar style="height: 100%;width: 100%;">
          <div class="content2_box">
            <component ref="componentRef" @changeNumber="changeMenuNumber" :is="currentComponent"></component>
          </div>
        </el-scrollbar>
      </div>
    </div>

  </div>
</template>

<script>
import BasicInformationCompany from "../../../components/companyModule/BasicInformationCompany.vue";
import BusinessInformation from "../../../components/companyModule/BusinessInformation.vue";
import CompanyAlbum from "../../../components/companyModule/CompanyAlbum.vue";
import CompanyIntroduction from "../../../components/companyModule/CompanyIntroduction.vue";
import TalentDevelopment from "../../../components/companyModule/TalentDevelopment.vue";
export default {
  name: "companyIntro",
  data() {
    return {
      currentMenu: 1,
      menuData: [
        {
          name: "公司基本信息",
          id: 1,
          number: 6,
          current_num: 0,
        },
        {
          name: "公司介绍",
          id: 2,
        },
        {
          name: "公司相册",
          id: 3,
        },
        {
          name: "人才发展",
          id: 4,
        },
        {
          name: "工商信息",
          id: 5,
        },
      ],
    };
  },
  components: { BasicInformationCompany },
  computed: {
    currentComponent() {
      const componentMap = {
        1: BasicInformationCompany,
        2: CompanyIntroduction,
        3: CompanyAlbum,
        4: TalentDevelopment,
        5: BusinessInformation,
      };

      return componentMap[this.currentMenu];
    },
  },
  mounted() {
    if (localStorage.getItem("currentMenu")) {
      this.currentMenu = localStorage.getItem("currentMenu");
    } else {
      this.currentMenu = 1;
    }
    if (localStorage.getItem("finishNumber")) {
      this.menuData[0].current_num = localStorage.getItem("finishNumber");
    } else {
      this.menuData[0].current_num = 0;
    }
  },
  methods: {
    changeMenu(id) {
      this.currentMenu = id;
      localStorage.setItem("currentMenu", this.currentMenu);
    },
    changeMenuNumber(val) {
      this.menuData[0].current_num = val;
      localStorage.setItem("finishNumber", val);
    },
  },
};
</script>

<style scoped lang="scss">
.company-contain {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  box-sizing: border-box;
  .content_box {
    width: 1224px;
    display: flex;
    .left_menu {
      width: 220px;
      margin-right: 20px;
      flex-shrink: 0;
      .menu_item {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 36px;
        padding: 0 16px;
        box-sizing: border-box;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        margin-bottom: 10px;
        cursor: pointer;
      }
      .active_menu_item {
        color: #685ef5;
        background: #dedbff;
      }
    }
    .right_box {
      flex: 1;
      width: 0;
      height: calc(100vh - 140px);
      background: #fff;

      .content2_box {
        width: 100%;
        height: 100px;
        padding: 40px;
        box-sizing: border-box;
        background: #fff;
      }
    }
  }
}
:deep(.el-scrollbar__wrap) {
  overflow-x: hidden;
}
</style>
